import React from 'react';
import { ArrowRight, BoxIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from './ui/Card';
import { Button } from './ui/Button';
interface CalculatorCardProps {
  title: string;
  description: string;
  icon: BoxIcon;
  onClick: () => void;
}
export function CalculatorCard({
  title,
  description,
  icon: Icon,
  onClick
}: CalculatorCardProps) {
  return <Card className="flex flex-col h-full hover:border-blue-300 transition-all duration-300 group hover:shadow-xl hover:-translate-y-1 bg-white" data-id="element-13">
      <CardHeader data-id="element-14">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-slate-50 group-hover:bg-gradient-to-br group-hover:from-blue-500 group-hover:to-blue-600 transition-all duration-300 shadow-sm" data-id="element-15">
          <Icon className="h-6 w-6 text-slate-600 group-hover:text-white transition-colors" data-id="element-16" />
        </div>
        <CardTitle className="text-xl group-hover:text-blue-700 transition-colors" data-id="element-17">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex-1" data-id="element-18">
        <CardDescription className="text-base leading-relaxed" data-id="element-19">
          {description}
        </CardDescription>
      </CardContent>
      <CardFooter data-id="element-20">
        <Button variant="ghost" className="w-full justify-between group-hover:text-blue-600 group-hover:bg-blue-50 font-medium" onClick={onClick} data-id="element-21">
          Vergleich starten{' '}
          <ArrowRight className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-22" />
        </Button>
      </CardFooter>
    </Card>;
}